import { useContent } from '../content/ContentContext.jsx'
import { Em } from '../components/Em.jsx'
import { Icon } from '../components/Icon.jsx'
import { SectionNum } from '../components/SectionNum.jsx'

export function DifferenceSection() {
  const { content } = useContent()
  const d = content.difference
  return (
    <section className="section diff" id="sec-difference">
      <SectionNum sectionKey="difference" />
      <h2>
        <Em pre={d.pre} em={d.em} post={d.post} />
      </h2>
      <div className="cmp">
        <div className="cmp-head">
          <span className="a">{d.headA}</span>
          <span></span>
          <span className="b">{d.headB}</span>
        </div>
        {d.rows.map((r, i) => (
          <div className="cmp-row" key={i}>
            <div className="agency">{r.a}</div>
            <div className="arrow">
              <Icon name="arrowRight" size={20} />
            </div>
            <div className="advisory">{r.b}</div>
          </div>
        ))}
      </div>
      <p className="diff-statement">{d.statement}</p>
    </section>
  )
}
